import { Container, Row, Col } from 'react-bootstrap';
import { FaInstagram, FaEnvelope, FaDownload, FaEye } from 'react-icons/fa';
import NewsletterSignup from './NewsletterSignup';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const lightMuted = 'rgba(255, 255, 255, 0.75)';

  const iconLinkStyle = {
    width: '34px',
    height: '34px',
    borderRadius: '50%',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
  };

  const navLinkStyle = {
    fontSize: '14px',
    color: '#fff',
    textDecoration: 'none',
  };

  return (
    <footer className="mt-5" style={{ backgroundColor: '#697778', color: '#fff' }}>
      <Container className="py-4">
        <Row className="gy-4">
          {/* Brand + social */}
          <Col xs={12} md={4}>
            <div className="mb-2" style={{ fontWeight: 500 }}>
              LIMBISM
            </div>
            <p className="small mt-2 mb-3" style={{ color: lightMuted }}>
              Connect on social media or drop me a line!
            </p>
            <div className="d-flex gap-2">
              <a
                href="https://www.instagram.com/limbism/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Limbism on Instagram"
                style={iconLinkStyle}
              >
                <FaInstagram size={18} />
              </a>
              <a
                href="mailto:limbism.art@gmail.com"
                aria-label="Email Limbism"
                style={iconLinkStyle}
              >
                <FaEnvelope size={16} />
              </a>
            </div>
          </Col>

          {/* For galleries */}
          <Col xs={12} md={4}>
            <div className="mb-2" style={{ fontWeight: 500 }}>
              FOR GALLERIES
            </div>
            <div className="small mt-2 mb-3" style={{ color: lightMuted }}>
              Creative Portfolio
            </div>
            <div className="d-flex flex-column gap-2">
              <a href="/LIMBISM_CP.pdf" download style={navLinkStyle}>
                <FaDownload size={13} className="me-2" />
                Download
              </a>
              <a
                href="https://www.canva.com/design/DAG_czeg6Is/f-3AYtzH9gXFmFn1CVTtfw/view?utm_content=DAG_czeg6Is&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h2671afae6a"
                target="_blank"
                rel="noopener noreferrer"
                style={navLinkStyle}
              >
                <FaEye size={13} className="me-2" />
                View online
              </a>
            </div>
          </Col>

          {/* Newsletter */}
          <Col xs={12} md={4}>
            <div className="mb-2" style={{ fontWeight: 500 }}>
              FOR COLLECTORS
            </div>
            <p className="small mb-3" style={{ color: lightMuted }}>
              No spam or pressure. Just new work updates, upcoming shows, and
              exciting announcements now and then.
            </p>
            <NewsletterSignup variant="inline" />
          </Col>
        </Row>

        <Row
          className="mt-4 pt-3"
          style={{ borderTop: '1px solid rgba(255, 255, 255, 0.2)' }}
        >
          <Col xs={12} className="text-center small" style={{ color: lightMuted }}>
            No AI is ever used in the creative process and execution - saving
            art for the humans.&emsp;
            <span style={{ fontWeight: 500, color: '#fff' }}>
              Limbism &copy; {currentYear}
            </span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
